import React from 'react';
import css from './SectionHero.module.css';
import Slider from 'react-slick';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';

import { createResourceLocatorString } from '../../../util/routes';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import banner1 from './bannerImage.jpg';
import classNames from 'classnames';

function SectionHero(props) {
  const {
    intl,
    sliderSettings = {
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 500,
      cssEase: 'ease-in-out',
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      focusOnSelect: false,
      centerMode: false,
      responsive: [
        { breakpoint: 1128, settings: { slidesToShow: 1 } },
        { breakpoint: 991, settings: { slidesToShow: 1 } },
        { breakpoint: 767, settings: { slidesToShow: 1 } },
        { breakpoint: 580, settings: { slidesToShow: 1 } },
      ],
    },
    isMobileLayout,
  } = props;

  const routeConfiguration = useRouteConfiguration();
  const history = useHistory();

  const onRedirectTo = (page, params) => {
    history.push(createResourceLocatorString(page, routeConfiguration, params, {}));
  };

  return (
    <div className={css.heroWrapper}>
      <div className={css.heroContent}>
        <div className={css.heroInnerContent}>
          <h1 className={css.heroMainTitle}>
            {intl.formatMessage({ id: 'SectionHero.title' })}
          </h1>

          <p className={css.heroSubTitle}>
            {intl.formatMessage({ id: 'SectionHero.subtitles' })}
          </p>

          <div className={css.formContainer}>
            <div className={css.tabs}>
              <span
                className={classNames(css.tab, css.active)}
                role="button"
                onClick={() => onRedirectTo('SearchPage')}
              >
                {intl.formatMessage({ id: 'SectionHero.tab.shopNow' })}
              </span>

              <span
                className={css.tab}
                role="button"
                onClick={() => onRedirectTo('NewListingPage')}
              >
                {intl.formatMessage({ id: 'SectionHero.tab.listYourGear' })}
              </span>
            </div>
          </div>
        </div>
      </div>

      <Slider {...{ ...sliderSettings, arrows: !isMobileLayout }}>
        <div className={css.heroBannerImgSec}>
          <img
            src={banner1}
            alt={intl.formatMessage({ id: 'SectionHero.bannerAlt' })}
          />
        </div>
      </Slider>
    </div>
  );
}

export default SectionHero;
